import type { HTMLAttributes } from 'react';
import { cn } from './cn';

type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

// Tinted rather than solid — badges label, they shouldn't compete with buttons.
const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-background-alt text-text-secondary border-border',
  accent: 'bg-primary/10 text-primary border-primary/20',
  success: 'bg-success/10 text-success border-success/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  danger: 'bg-error/10 text-error border-error/20',
  info: 'bg-info/10 text-info border-info/20',
};

export const Badge = ({ tone = 'neutral', className, ...props }: BadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5',
      'text-overline font-semibold uppercase font-sans',
      TONES[tone],
      className,
    )}
    {...props}
  />
);

export default Badge;
